module.exports = __webpack_public_path__ + "static/img/001.6eb7d4bc.png";